(() => {
  function initMarket(market) {
    const search = market.querySelector('[data-pm-search]');
    const categoryRail = market.querySelector('[data-pm-categories]');
    const typeButtons = [...market.querySelectorAll('[data-pm-type]:not([data-pm-product])')].filter(btn => btn.hasAttribute('data-pm-type') && btn.tagName === 'BUTTON');
    const cards = [...market.querySelectorAll('[data-pm-product]')];
    const empty = market.querySelector('[data-pm-empty]');
    const countLabel = market.querySelector('[data-pm-count]');
    const categoryHeading = market.querySelector('[data-pm-selected-title]');
    const categorySummary = market.querySelector('[data-pm-selected-subtitle]');
    let game = 'all';
    let productType = 'all';

    // Game categories for future products come from Shopify tags like "game:Rust".
    // Uses the existing Shopify product image, not external URLs or hard-coded artwork.
    if (categoryRail) {
      const known = new Set([...categoryRail.querySelectorAll('[data-pm-game]')].map(item => item.dataset.pmGame));
      const dynamicGames = new Map();
      for (const card of cards) {
        const key = card.dataset.pmGame;
        if (!key || known.has(key) || dynamicGames.has(key)) continue;
        dynamicGames.set(key, {name: card.dataset.pmGameName || 'More products', image: card.dataset.pmImage || ''});
      }
      for (const [key, data] of dynamicGames) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'pm-category-card pm-category-dynamic';
        button.dataset.pmGame = key;
        button.dataset.pmLabel = data.name;
        button.setAttribute('aria-pressed', 'false');
        const visual = document.createElement('span');
        visual.className = 'pm-category-image';
        if (data.image) {
          const img = document.createElement('img');
          img.src = data.image;
          img.alt = '';
          img.loading = 'lazy';
          visual.appendChild(img);
        } else {
          visual.classList.add('pm-category-fallback');
          visual.textContent = data.name.slice(0, 1).toUpperCase();
        }
        const shade = document.createElement('span');
        shade.className = 'pm-category-shade';
        const info = document.createElement('span');
        info.className = 'pm-category-info';
        const eyebrow = document.createElement('span');
        eyebrow.className = 'pm-category-overline';
        eyebrow.textContent = key === 'other' ? 'MORE' : 'GAME';
        const name = document.createElement('strong');
        name.textContent = data.name;
        info.append(eyebrow, name);
        const arrow = document.createElement('span');
        arrow.className = 'pm-category-arrow';
        arrow.setAttribute('aria-hidden', 'true');
        arrow.textContent = '↗';
        button.append(visual, shade, info, arrow);
        categoryRail.append(button);
      }
    }

    function render() {
      const q = (search?.value || '').trim().toLocaleLowerCase();
      let shown = 0;
      for (const card of cards) {
        const matchesGame = game === 'all' || card.dataset.pmGame === game;
        const matchesType = productType === 'all' || card.dataset.pmType === productType;
        const matchesSearch = !q || (card.dataset.pmTitle || '').includes(q);
        const visible = matchesGame && matchesType && matchesSearch;
        card.hidden = !visible;
        if (visible) shown++;
      }
      if (empty) empty.hidden = shown > 0;
      if (countLabel) countLabel.textContent = shown + (shown === 1 ? ' product' : ' products');
      for (const btn of typeButtons) {
        const isActive = btn.dataset.pmType === productType;
        btn.classList.toggle('active', isActive);
        btn.setAttribute('aria-pressed', String(isActive));
      }
      if (categoryRail) {
        for (const btn of categoryRail.querySelectorAll('[data-pm-game]')) {
          const selected = btn.dataset.pmGame === game;
          btn.classList.toggle('is-active', selected);
          btn.setAttribute('aria-pressed', String(selected));
        }
      }
    }

    categoryRail?.addEventListener('click', evt => {
      const btn = evt.target.closest('[data-pm-game]');
      if (!btn || !categoryRail.contains(btn)) return;
      game = btn.dataset.pmGame || 'all';
      productType = 'all';
      if (search) search.value = '';
      const title = btn.dataset.pmLabel || 'All games';
      if (categoryHeading) categoryHeading.textContent = game === 'all' ? 'All products' : title + ' products';
      if (categorySummary) categorySummary.textContent = game === 'all' ? 'Explore packages and select your preferred license.' : 'Available products for ' + title + '. Choose your preferred license below.';
      render();
      const results = market.querySelector('#predator-products');
      if (results) results.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
    });

    for (const btn of typeButtons) {
      btn.addEventListener('click', () => {
        productType = btn.dataset.pmType || 'all';
        render();
      });
    }
    search?.addEventListener('input', render);

    for (const card of cards) {
      const chooser = card.querySelector('[data-pm-variant-select]');
      const buy = card.querySelector('[data-pm-checkout]');
      const price = card.querySelector('[data-pm-price]');
      if (!chooser || !buy) continue;
      chooser.addEventListener('change', () => {
        const option = chooser.selectedOptions[0];
        if (!option) return;
        if (price) price.textContent = option.dataset.price || '';
        const available = option.dataset.available === 'true';
        if (available) {
          buy.href = buy.dataset.pmPrefix + encodeURIComponent(option.value) + ':1';
          buy.classList.remove('pm-disabled');
          buy.removeAttribute('aria-disabled');
          buy.removeAttribute('tabindex');
        } else {
          buy.removeAttribute('href');
          buy.classList.add('pm-disabled');
          buy.setAttribute('aria-disabled', 'true');
          buy.setAttribute('tabindex', '-1');
        }
      });
    }
    render();
  }
  function init() {document.querySelectorAll('[data-predator-market]').forEach(initMarket);}
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
